// Generation must stay on the same-origin proxy: the backend authenticates the
// requester by their zep.us session cookie, and a cross-origin call to the
// backend host sends that host's cookies instead, never zep.us's.
export const AI_MAP_API_BASE = '/ai-map-api';
export const AI_MAP_STATIC_BASE = process.env.NEXT_PUBLIC_AI_MAP_API_URL
  ? `${process.env.NEXT_PUBLIC_AI_MAP_API_URL}/static`
  : '/ai-map-static';

export const AI_MAP_GENERATION_COST_ZEM = 10;
export const AI_MAP_MAX_REFERENCE_IMAGES = 3;
export const AI_MAP_ACCEPTED_IMAGE_DESCRIPTION = 'JPG, PNG, WebP';
export const AI_MAP_DEFAULT_PROMPT_PLACEHOLDER =
  '만들고 싶은 맵을 자유롭게 설명해 주세요';
// Shown once a map is finished: sending again starts a brand-new generation.
export const AI_MAP_NEW_MAP_PROMPT_PLACEHOLDER = '새로 만들 맵을 설명해 주세요';
export const AI_MAP_INTRO_MESSAGE =
  '어떤 맵을 만들고 싶나요?\n설명을 입력하거나 + 버튼으로 참고 이미지를 첨부해 주세요.';

// The only browser-side persistence. Holds the payload of the request that is
// in flight so the same requestId can be re-sent after a refresh.
export const AI_MAP_REQUEST_DRAFT_STORAGE_KEY = 'ai-map-request-draft';
export const AI_MAP_LONG_WAIT_NOTICE_DELAY_MS = 30_000;

// Served from web-app's own public dir; /images/* is rewritten to the CDN on
// dev environments and 404s there.
export const AI_MAP_LOADER_EMBLEM_SRC = '/ai-map/loader-symbol.png';

// Mirrors the backend's _validate_session_id.
export const AI_MAP_SESSION_ID_PATTERN = /^[A-Za-z0-9_-]{1,128}$/;

// Region edit: mirrors the backend's EDIT_MIN_REGION_PX.
export const AI_MAP_EDIT_MIN_REGION_PX = 16;
export const AI_MAP_EDIT_PROMPT_PLACEHOLDER = '선택한 영역을 어떻게 바꿀까요?';
export const AI_MAP_EDIT_HINT = '드래그로 영역을 다시 고르거나 Esc 로 해제';
